import { Injectable, NgZone, inject } from '@angular/core';
import {Player} from "../model/players";
import {GameService} from "./game.service";
import {PlayerPositions} from "../model/playerPositions";

/**
 * Ceci permet de définir le lineup de la partie Démo.
 * Utile pour les tests automatisés.
 *
 * Exemple d'utilisation dans la console
 *
 * ```
 *     window.chargerDonneesLineup({
 *       home: {
 *         nom: 'hometeam',
 *         abrev: 'HT',
 *         positions: {
 *           qb: [1],
 *           rb: [2],
 *           wr: [3],
 *           ol: [4],
 *           dl: [5],
 *           lb: [6],
 *           db: [7],
 *           k: [8],
 *         }
 *       },
 *       away: {
 *         nom: 'awayteam',
 *         abrev: 'AT',
 *         positions: {
 *           qb: [11],
 *           rb: [12],
 *           wr: [13],
 *           ol: [14],
 *           dl: [15],
 *           lb: [16],
 *           db: [17],
 *           k: [18],
 *         }
 *       }
 *     })
 * ```
 */
@Injectable({
  providedIn: 'root',
})
export class DebugService {
  private game = inject(GameService);
  private ngZone = inject(NgZone);


  chargerDonneesLineup(params: any): void {
    console.log('Chargement des données de lineup...');

    this.game.game.homeTeam = {
      ...this.game.game.homeTeam,
      teamShortName: params.home.nom,
      teamNameAbr: params.home.abrev
    }
    this.game.game.awayTeam = {
      ...this.game.game.awayTeam,
      teamShortName: params.away.nom,
      teamNameAbr: params.away.abrev
    }

    const fakeHomeLineUp2 = this.generatePlayers(params.home.positions);
    const fakeAwayLineUp2 = this.generatePlayers(params.away.positions);

    this.ngZone.run(() => {
      this.game.lineUp.loadLineUpDemo({
        homeLineups: {
          teamId: 'a229b14b-cdbe-47f1-abb4-b77e01bcc4ad',
          seasonId: '5eada734-c79b-4275-9c0a-16d383f77463',
          players: fakeHomeLineUp2
        },
        awayLineups: {
          teamId: "ddf2ece8-64c7-4efd-8121-090b44748ac5",
          seasonId: "5eada734-c79b-4275-9c0a-16d383f77463",
          players: fakeAwayLineUp2
        }
      })
    })
  }

  generatePlayers(data: any): Player[] {
    const numerosJoueurs= this.extractTousLesNumerosJoueur(data);

    const players: any = []
    numerosJoueurs.forEach(noJoueur => {
      const positions = this.extractPositionJoueur(data, noJoueur)
      players.push(this.generatePlayer(noJoueur, positions))
    })

    return players
  }

  private extractPositionJoueur(data: any, joueur: number): string[] {
    const abrevPosition: any = {
      qb: 'QB', // Quater back
      rb: 'RB', // Running back
      wr: 'WR', // Wide receiver
      ol: 'OL', // Offensive lineman
      dl: 'DL', // Defensive lineman
      lb: 'LB', // Line Backer
      db: 'DB', // Defensive back
      k: 'K'    // Kicker // defensive lineman
    }

    // retourner position abreviation
    return Object.entries(data)
      .filter((positionData: any) => positionData[1].includes(joueur))
      .map(role => role[0])
      .map(role => abrevPosition[role])
  }

  private extractTousLesNumerosJoueur(data: any): number[] {
    // Trouver tous les joueurs
    const a: any[] = []
    Object.entries(data).forEach((positionData: any) => {
      a.push(...positionData[1])
    })
    return Array.from(new Set(a.sort((a, b) => a - b)))
  }

  generatePlayer(playerNumber: number, positions: string[]): Player {
    const playerData = {
      playerId: playerNumber.toString(),
      playerName: "Joueur " + playerNumber,
      jerseyNumber: playerNumber,
    }

    const playerPositions: PlayerPositions[] = positions.map(position => {
      return {
        "position": position
      }
    })

    return {
      "id": playerData.playerId,
      "fullName": playerData.playerName,
      "jerseyNumber": playerData.jerseyNumber,
      "teamId": "teamId",
      "seasonId": "seasonId",
      "gamesPlayed": [
        {
          "gameJerseyNumber": playerData.jerseyNumber
        }
      ],
      "playerPositions": [
        ...playerPositions
      ]
    }
  }
}
